import { Dispatch } from 'redux';
import {
  HOME_SET_WIDGET_PREFERENCES,
  HOME_UPDATE_WIDGET_PREFERENCE,
  HOME_RECORD_QUICK_LINK_CLICK,
} from '@core/constants/actions';
import * as api from '@core/api/homeScreen/homeScreenPreferences';
import * as quickLinksApi from '@core/api/homeScreen/homeQuickLinks';
import showToast from '@core/toasts/operations/showToast.operation';
import widgetsLibrary from '@app/components/presentational/Home/widgetsLibrary';

export const fetchWidgetPreferences = () => async (dispatch: Dispatch) => {
  try {
    const response = await api.fetchWidgetPreferences();
    const apiPreferences = response.homeUserPreferences || [];

    // Ensure every widget in widgetsLibrary has a preference entry
    const mergedPreferences = widgetsLibrary.map((widget) => {
      const existing = apiPreferences.find(
        (p: any) => p.widgetId === widget.id
      );
      return (
        existing || {
          widgetId: widget.id,
          isHidden: false,
        }
      );
    });

    dispatch({
      type: HOME_SET_WIDGET_PREFERENCES,
      preferences: mergedPreferences,
    });
  } catch (error) {
    console.error('Failed to fetch widget preferences', error);
  }
};

export const toggleWidgetPreference =
  (widgetId: string, isHidden: boolean) => async (dispatch: Dispatch) => {
    // Optimistic UI: update local state immediately, persist in background.
    dispatch({
      type: HOME_UPDATE_WIDGET_PREFERENCE,
      widgetId,
      isHidden,
    });

    try {
      await api.patchWidgetPreference(widgetId, isHidden);
    } catch (error) {
      console.error('Failed to update widget preference', error);
      dispatch({
        type: HOME_UPDATE_WIDGET_PREFERENCE,
        widgetId,
        isHidden: !isHidden,
      });
      // Use any as Dispatch doesn't natively support thunks in the standard redux typing without extra configuration
      (dispatch as any)(
        showToast({
          message: 'Failed to update widget visibility',
          variant: 'error',
        })
      );
    }
  };

export const recordQuickLinkClick =
  (linkKey: string, role: string) => async (dispatch: Dispatch) => {
    dispatch({
      type: HOME_RECORD_QUICK_LINK_CLICK,
      linkKey,
      role,
    });

    try {
      await quickLinksApi.patchQuickLinkClick(linkKey, role);
    } catch (error) {
      console.error('Failed to record quick link click', error);
    }
  };
